<div *ngIf="!hideSearchComponent">
  <app-search [placeholder]="searchPlaceHolder" (search)="filter($event)">
  </app-search>
</div>
<mat-selection-list color="primary" (selectionChange)="handleEvent($event)">
  <mat-checkbox
    color="primary"
    class="all-select-checkbox-simple-list"
    [checked]="allSelected"
    (change)="selectAllClicked()"
    [indeterminate]="isPartiallySelected()"
  >
    <span class="all-select-checkbox-simple-list-label">{{
      selectAllText
    }}</span>
  </mat-checkbox>
  <mat-divider></mat-divider>
  <div class="scrollable-area">
    <mat-list *ngFor="let item of workingList">
      <mat-list-option
        checkboxPosition="before"
        [value]="item"
        [selected]="item.isChecked"
      >
        <div class="item-image-text">
          <img
            class="item-image"
            src="{{ item.imageUrl }}"
            *ngIf="!hidePhoto"
          />
          <span class="item-text">
            {{ item.name }}
          </span>
        </div>
      </mat-list-option>
    </mat-list>
  </div>
</mat-selection-list>
<mat-divider></mat-divider>
<div class="buttons" *ngIf="!hideButtons">
  <button class="btn-reset" mat-button (click)="resetSelection()"
    [disabled]="!hasItemChecked"
  >
    Limpar
  </button>
  <button class="btn-apply" mat-raised-button (click)="applySelection()"
    [disabled]="!hasItemChanged"
  >
    Aplicar
  </button>
</div>
